import { useState } from "react";
import { Pencil, Plus, Save, Trash2, X } from "lucide-react";
import { toast } from "sonner";
import { api, CURRENCIES, errMsg, money, PAY_STATUSES, STAGES } from "../api";
import { useAuth } from "../auth";

const StatusBadge = ({ s }) => <em className={`status ${s === "Bekliyor" ? "status-amber" : s === "Planlanan" ? "status-blue" : "status-green"}`}>{s}</em>;

export default function PaymentsPanel({ prj, reload, onQuickPay }) {
  const { can } = useAuth();
  const editable = can("admin", "project_manager", "finance");
  const [edit, setEdit] = useState(null);
  const set = (k) => (e) => setEdit({ ...edit, [k]: e.target.value });

  const save = async (e) => {
    e.preventDefault();
    try {
      await api.put(`/payments/${edit.id}`, { ...edit, amount: Number(edit.amount) || 0, date: edit.date || null, due_date: edit.due_date || null, project_id: prj.id, project_name: prj.name });
      toast.success("Ödeme güncellendi"); setEdit(null); reload();
    } catch (err) { toast.error(errMsg(err)); }
  };
  const remove = async (p) => { if (!window.confirm("Ödeme silinsin mi?")) return; await api.delete(`/payments/${p.id}`); toast.success("Ödeme silindi"); reload(); };

  return (
    <section className="panel" data-testid="payments-panel">
      <div className="panel-head">
        <div><span className="eyebrow">ÖDEMELER</span><h2>Gelen ve giden ödemeler</h2></div>
        {editable && <button className="new-btn" onClick={() => onQuickPay({ project_id: prj.id })} data-testid="project-quick-pay-button"><Plus size={15} /> Ödeme kaydet</button>}
      </div>
      <div className="project-table">
        <div className="table-row table-head pay-row"><span>YÖN</span><span>AŞAMA</span><span>ALT YÜK. / KALEM</span><span>TUTAR</span><span>TARİH / VADE</span><span>DURUM</span><span></span></div>
        {prj.payments.map((p, i) => edit?.id === p.id ? (
          <form className="inline-form edit-row" key={p.id} onSubmit={save} data-testid={`edit-pay-form-${i}`}>
            <select value={edit.direction} onChange={set("direction")}><option value="outgoing">Giden</option><option value="incoming">Gelen</option></select>
            <select value={edit.stage} onChange={set("stage")}>{STAGES.map((s) => <option key={s}>{s}</option>)}</select>
            <input placeholder="Alt yüklenici" value={edit.subcontractor_short || ""} onChange={set("subcontractor_short")} />
            <input type="number" step="0.01" value={edit.amount} onChange={set("amount")} data-testid={`edit-pay-amount-${i}`} />
            <select value={edit.currency} onChange={set("currency")}>{CURRENCIES.map((c) => <option key={c}>{c}</option>)}</select>
            <input type="date" value={(edit.date || "").slice(0, 10)} onChange={set("date")} title="Ödeme tarihi" />
            <input type="date" value={(edit.due_date || "").slice(0, 10)} onChange={set("due_date")} title="Vade" data-testid={`edit-pay-due-${i}`} />
            <select value={edit.status} onChange={set("status")} data-testid={`edit-pay-status-${i}`}>{PAY_STATUSES.map((s) => <option key={s}>{s}</option>)}</select>
            <input placeholder="Açıklama" value={edit.description || ""} onChange={set("description")} />
            <div className="row-actions"><button className="new-btn" data-testid={`edit-pay-save-${i}`}><Save size={14} /></button><button type="button" className="ghost-btn" onClick={() => setEdit(null)}><X size={14} /></button></div>
          </form>
        ) : (
          <div className="table-row pay-row" key={p.id} data-testid={`pay-row-${i}`}>
            <em className={`status ${p.direction === "incoming" ? "status-green" : "status-amber"}`}>{p.direction === "incoming" ? "Gelen" : "Giden"}</em>
            <span>{p.stage}</span>
            <div><b className="text-line">{p.subcontractor_short || (p.direction === "incoming" ? prj.employer_short : "—")}</b><small className="text-line muted">{p.work_item_category || p.description || ""}</small></div>
            <b className="mono-small">{money(p.amount, p.currency)}</b>
            <div><b className="text-line mono-small">{p.date ? p.date.slice(0, 10) : "—"}</b>{p.due_date && <small className="text-line muted">vade {p.due_date.slice(0, 10)}</small>}</div>
            <StatusBadge s={p.status} />
            <div className="row-actions">
              {editable && <button className="row-action" onClick={() => setEdit({ ...p })} data-testid={`edit-pay-${i}`}><Pencil size={13} /></button>}
              {editable && <button className="row-action danger" onClick={() => remove(p)} data-testid={`delete-pay-${i}`}><Trash2 size={13} /></button>}
            </div>
          </div>
        ))}
        {!prj.payments.length && <div className="empty-hint">Ödeme kaydı yok.</div>}
      </div>
    </section>
  );
}
